// Helpers de escala y geometría para los gráficos del dashboard (sin dependencias).

export const clamp = (v, a, b) => Math.min(b, Math.max(a, v));

// Punto en polares; 0° = las 12 en punto, sentido horario.
export function polar(cx, cy, r, deg) {
  const a = ((deg - 90) * Math.PI) / 180;
  return { x: cx + r * Math.cos(a), y: cy + r * Math.sin(a) };
}

// Arco (trazo) de a0 a a1 grados, horario.
export function arcPath(cx, cy, r, a0, a1) {
  const s = polar(cx, cy, r, a0);
  const e = polar(cx, cy, r, a1);
  const large = a1 - a0 > 180 ? 1 : 0;
  return `M${s.x.toFixed(2)} ${s.y.toFixed(2)} A${r} ${r} 0 ${large} 1 ${e.x.toFixed(2)} ${e.y.toFixed(2)}`;
}

// Treemap "squarified" (Bruls et al.). items: [{ value, ... }] ya ordenados desc.
// Devuelve [{ item, x, y, w, h }] que llenan el rectángulo.
export function squarify(items, x, y, w, h) {
  const out = [];
  const list = items.filter((i) => i.value > 0).slice();
  const total = list.reduce((s, i) => s + i.value, 0);
  if (!list.length || w <= 0 || h <= 0 || total <= 0) return out;
  const scale = (w * h) / total;
  const nodes = list.map((item) => ({ item, area: item.value * scale }));

  const worst = (row, side) => {
    const sum = row.reduce((s, n) => s + n.area, 0);
    const max = Math.max.apply(null, row.map((n) => n.area));
    const min = Math.min.apply(null, row.map((n) => n.area));
    return Math.max((side * side * max) / (sum * sum), (sum * sum) / (side * side * min));
  };

  let rect = { x, y, w, h };
  let row = [];
  let i = 0;
  const layoutRow = () => {
    const sum = row.reduce((s, n) => s + n.area, 0);
    if (rect.w >= rect.h) {
      const colW = sum / rect.h;
      let cy = rect.y;
      row.forEach((n) => {
        const nh = n.area / colW;
        out.push({ item: n.item, x: rect.x, y: cy, w: colW, h: nh });
        cy += nh;
      });
      rect = { x: rect.x + colW, y: rect.y, w: rect.w - colW, h: rect.h };
    } else {
      const rowH = sum / rect.w;
      let cx = rect.x;
      row.forEach((n) => {
        const nw = n.area / rowH;
        out.push({ item: n.item, x: cx, y: rect.y, w: nw, h: rowH });
        cx += nw;
      });
      rect = { x: rect.x, y: rect.y + rowH, w: rect.w, h: rect.h - rowH };
    }
    row = [];
  };
  while (i < nodes.length) {
    const side = Math.min(rect.w, rect.h);
    const next = nodes[i];
    if (!row.length || worst(row.concat(next), side) <= worst(row, side)) {
      row.push(next);
      i++;
    } else {
      layoutRow();
    }
  }
  if (row.length) layoutRow();
  return out;
}
